import { render, staticRenderFns } from "./BankList.vue?vue&type=template&id=ffef1506"
import script from "./BankList.vue?vue&type=script&lang=js"
export * from "./BankList.vue?vue&type=script&lang=js"
import style0 from "./BankList.vue?vue&type=style&index=0&id=ffef1506&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports